import { atom } from 'jotai/vanilla';

export const segmentFeatureFlag = atom(false);
export const topSubjectsFeatureFlag = atom(true);
export const hireVueLinkFeatureFlag = atom(false);
